import React, { useState } from 'react';
import styled from 'styled-components';

import { color } from 'ui';
import DashboardLayout from '../layouts/dashboard';
import SignOutModal from '../modules/account-settings/components/modals/SignOutModal';
import AccountSettingsTab from '../modules/account-settings/components/AccountSettingsTab';

const AccountSettings = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const onSignOutModalOpen = () => {
    setOpenModal((state) => !state);
  };
  return (
    <DashboardLayout name="Account">
      <Container>
        <AccountSettingsTab />
        {openModal && (
          <SignOutModal
            openModal={openModal}
            setOpenModal={setOpenModal}
            onSignOutModalOpen={onSignOutModalOpen}
          />
        )}
      </Container>
    </DashboardLayout>
  );
};

export default AccountSettings;

const Container = styled.div`
  background: ${color.white};
  width: 100%;
  padding: 1.5rem;
`;
